import { render, staticRenderFns } from "./StudentDepartmentComponent.vue?vue&type=template&id=b5d71976&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./StudentDepartmentComponent.vue?vue&type=script&lang=js&"
export * from "./StudentDepartmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./StudentDepartmentComponent.vue?vue&type=style&index=0&id=b5d71976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d71976",
  null
  
)

component.options.__file = "StudentDepartmentComponent.vue"
export default component.exports